import {
  CarIcon,
  User2Icon,
  UserCheck,
  UserCircle2,
  TrendingUp,
  Wallet,
  History,
} from "lucide-react";
import StatCard from "../components/cards/StatCard";
import { useEffect, useState } from "react";
import { getClients } from "../services/client.service";
import { getCompanyStats } from "../services/stat.service";
import { getOrders } from "../services/order.service";
import { getDrivers } from "../services/driver.service";
import "./dashboard.css";
import DriversMap from "../components/drivermap/DriversMap";

export default function Dashboard() {
  const [totalClients, setTotalClients] = useState(0);
  const [getOrdersCount, setOrdersCount] = useState(0);
  const [totalDrivers, setTotalDrivers] = useState(0);
  const [activeDrivers, setActiveDrivers] = useState(0);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    loadDashboard();
  }, []);

  async function loadDashboard() {
    setLoading(true);
    try {
      // ÉTAPE CLÉ : On ajoute getCompanyStats() dans le tableau des promesses
      const [clientsRes, driversRes, ordersRes, statsRes] = await Promise.all([
        getClients(),
        getDrivers(),
        getOrders(),
        getCompanyStats(), // <--- C'est cet appel qui récupère les gains
      ]);

      // --- Traitement des compteurs classiques ---
      const clientsData = clientsRes?.data || clientsRes || [];
      const driversData = driversRes?.data || driversRes || [];
      const ordersData = ordersRes?.data || ordersRes || [];

      setOrdersCount(ordersRes?.total ?? ordersData.length);
      setTotalClients(clientsRes?.total ?? clientsData.length);
      setTotalDrivers(driversRes?.total ?? driversData.length);

      const active = driversData.filter(
        (d) => d.isAvailable === true || d.isAvailable === 1,
      );
      setActiveDrivers(active.length);

      // --- TRAITEMENT DES GAINS ---
      console.log("Données reçues du PHP:", statsRes); // Pour vérifier dans ta console F12

      if (statsRes?.success) {
        setStats(statsRes.data);
      } else if (statsRes) {
        setStats(statsRes); // Au cas où la structure est directe
      }
    } catch (err) {
      console.error("Erreur lors du chargement du Dashboard:", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="dash">
      <div className="earningsRow">
        <StatCard
          title="Aujourd'hui"
          value={
            loading ? "..." : `${(stats?.gainDuJour || 0).toLocaleString()} CFA`
          }
          icon={Wallet}
          accent="indigo"
        />
        <StatCard
          title="Cette semaine"
          value={
            loading
              ? "..."
              : `${(stats?.gainHebdomadaire || 0).toLocaleString()} CFA`
          }
          icon={TrendingUp}
          accent="blue"
        />
        <StatCard
          title="Ce mois"
          value={
            loading
              ? "..."
              : `${(stats?.gainMensuelle || 0).toLocaleString()} CFA`
          }
          icon={TrendingUp}
          accent="orange"
        />
        <StatCard
          title="Total Gains"
          value={
            loading ? "..." : `${(stats?.gainTotal || 0).toLocaleString()} CFA`
          }
          icon={History}
          accent="green"
        />
      </div>

      <div className="mainGrid">
        <section className="panel mapPanel">
          <div className="mapWrapper">
            <DriversMap />
          </div>
        </section>

        <aside className="statsSidebar">
          <StatCard
            title="Chauffeurs Actifs"
            value={activeDrivers}
            icon={UserCheck}
            accent="blue"
            type="sidebar"
          />
          <StatCard
            title="Clients"
            value={totalClients}
            icon={User2Icon}
            accent="pink"
            type="sidebar"
          />
          <StatCard
            title="Chauffeurs"
            value={totalDrivers}
            icon={UserCircle2}
            accent="indigo"
            type="sidebar"
          />
        </aside>
      </div>
    </div>
  );
}
